
import { Placement } from '@post-office/placements-frontend/rovo-chat-sources';
export default Placement;
